import { getUserManager } from '@axa-fr/react-oidc-context';
import axios from 'axios';
import { User } from 'oidc-client';
import LocalStorageService from './LocalStorageService';

const FaraGostarDynamicHttp = async () => {
  const userPersonCode = LocalStorageService.getUserPersonCode();

  const um = (await getUserManager().getUser()) as User;
  const token = um.access_token;

  const headers = token ? { Authorization: `Bearer ${token}` } : {};
  const instance = axios.create({
    baseURL: window.config.apiUrl + userPersonCode + '/',
    headers,
  });

  return instance;
};

export default FaraGostarDynamicHttp;
